import { render, staticRenderFns } from "./VmIcon.vue?vue&type=template&id=24e2e2dd"
import script from "./VmIcon.vue?vue&type=script&lang=js"
export * from "./VmIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports